import { Panel } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import getHistorialMovPedidos from '../../../../utils/getHistorialMovPedidos';
import getPedidosPedidos from '../../../../utils/getPedidosPedidos';
import formatMoney from '../../../../utils/formatMoney';
import moment from 'moment';
import _ from 'lodash';


import {fetchPedidosColores,fetchPedidosUso,fetchSolicitudesFacturacion} from '../../../../actions';

const TableContent = (props) => {

  if (!props.solicitudfacturacion.length) {
    return (
      <tbody><tr><td colSpan='6' className='no-before'>No hay registros</td></tr></tbody>
    );
  }

  return props.solicitudfacturacion.map((facturacionListado, index) => {
    const isExpanded = index === props.rowSelected;
    const rowClass = isExpanded ? 'as row-expanded' : 'as';

    return (
      <tbody key={props.selectPedido + index} >
         <tr className={rowClass}>
          <td>{moment(facturacionListado.fecCreaReg).format('DD/MM/YYYY HH:mm')}</td>
          <td>{facturacionListado.desTipoPago}</td>
          <td onClick={() => props.toggleRow(index)}>{facturacionListado.desTipoSoli}</td>
        </tr>
        <tr className='table-extra'>
          <td colSpan='6'>
            <Panel  collapsible expanded={props.functionDespliegue(index)} style={{ borderColor: 'transparent', boxShadow: '0 0 0 white', margin: '0', backgroundColor: 'inherit' }}>
              <div className='collapse in'>
                <div className='table-extra-wrap'>
                  <ul>
                    <li>
                      <p className='labelInfo'>Solicitante</p>
                      <p>{facturacionListado.nomComercial}</p>
                    </li>
                    <li>
                      <p className='labelInfo'>Observaciones</p>
                      <p>{facturacionListado.obsFacturacion}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </Panel>
          </td>
        </tr>
      </tbody>
    );
  });
};



const TabHistorialCancelacion = (props) =>(
    <section className='fdv-section tab-pane active' id='adicionales'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Historial de Cancelacion de Pedido</h5>
    </header>
    <div className='tableWrapper'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
            <th>Estado</th>
            <th>Usuario</th>
            <th>Fecha</th>
            <th>Observacion</th>
          </tr>
        </thead>
        <tbody>
          {
            props.lstHistorialPedido.map((entity)=>
              <tr className='as' data-toggle='collapse' data-target='#pedidoFact0' aria-expanded='false' aria-controls='col'>
                <td>{entity.codUsuarioCancelacionPed}</td>
                <td>{entity.codUsuarioCreaReg}</td>
                <td>{moment(entity.fecCreaReg).format('DD/MM/YYYY')}</td>
                <td>{entity.observacion}</td>
            </tr>
            )
          }
        </tbody>
      </table>
    </div>
  </section>
);

const TabMovimientos = (props) =>(
    <section className='fdv-section tab-pane active' id='adicionales'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Movimientos</h5>
    </header>
    <div className='tableWrapper'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
            <th colspan="2">Documento</th>
            <th>fecha</th>
            <th>Moneda</th>
            <th>T.C</th>
            <th>Monto</th>
            <th>Saldo</th>
          </tr>
        </thead>
        <tbody>
          {
            props.lstMovimientosPagos.map((entity)=>
              <tr className='as' data-toggle='collapse' data-target='#pedidoFact0' aria-expanded='false' aria-controls='col'>
                <td>{entity.cod_tipo_doc}</td>
                <td>{entity.num_doc}</td>
                <td>{moment(entity.fec_docu).format('DD/MM/YYYY')}</td>
                <td>{entity.cod_moneda}</td>
                <td>{entity.val_tipo_cambio}</td>
                <td>{entity.val_monto}</td>
                <td>{entity.saldo}</td>

            </tr>
            )
          }
        </tbody>
      </table>
    </div>
  </section>
);

const Facturacion = (props) =>(
    <section className='fdv-section tab-pane active' id='pedidoFacturacion'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Datos de facturación</h5>
    </header>
    <div className='card card-plain card-lg'>
      <div className='row'>
        <div className='col-sm-4'>
          <label className='labelInfo'>Cliente facturación<i className='Sociedad de Abogados y asociados S.A.C ml-2' />
          </label>
          <p>{props.solicitudfacturacionEntity.nomCliente}</p>
        </div>
        <div className='col-sm-4'>
          <label className='labelInfo'>Cliente propietario
            </label>
          <p>{props.solicitudfacturacionEntity.nomPropietario}</p>
        </div>
        <div className='col-sm-4'>
          <label className='labelInfo'>Cliente usuario
            </label>
          <p>{props.solicitudfacturacionEntity.nomUsuario}</p>
        </div>
      </div>
      <hr />
      <div className='row'>
        <div className='col-sm-3'>
          <label className='labelInfo'>Documento
            </label>
          <p>{props.solicitudfacturacionEntity.desDocFact}</p>
        </div>
        <div className='col-sm-3'>
          <label className='labelInfo'>Tipo de pago
            </label>
          <p>{props.solicitudfacturacionEntity.desTipoPago}</p>
        </div>
        <div className='col-sm-3'>
          <label className='labelInfo'>Entidad Financiera
            </label>
          <p>{props.solicitudfacturacionEntity.desEntidadFinancieras}</p>
        </div>
      </div>
    </div>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Solicitudes realizadas</h5>
    </header>
    <div className='hidden-xs'>
      <div className='tableWrapper'>
        <table className='table table-hover table-accordion'>
          <thead className='table-head'>
            <tr>
              <th>Fecha</th>
              <th>Tipo de pago</th>
              <th>Tipo de solicitud</th>
            </tr>
          </thead>
            {

              <TableContent
              solicitudfacturacion = {props.solicitudfacturacion}
              selectPedido = {props.selectPedido}
              rowSelected= {props.rowSelected}
              functionDespliegue = {props.functionDespliegue}
              toggleRow = {props.toggleRow}
              />
            }
        </table>
      </div>
    </div>
  </section>
)


const TabDocumentos = (props) =>(
    <section className='fdv-section tab-pane active' id='adicionales'>
    <header className='fdv-section-head'>
      <h5 className='fdv-section-title'>Documentos de Ventas</h5>
    </header>
    <div className='tableWrapper'>
      <table className='table table-hover'>
        <thead className='table-head'>
          <tr>
              <th colspan="2">Documento</th>
              <th>Estado</th>
              <th>Fecha</th>
              <th>Moneda</th>
              <th>Monto</th>
              <th>Clase</th>
              <th>Tipo</th>
              <th colspan="2">Referencia</th>
          </tr>
        </thead>
        <tbody>
          {
            props.lstDocummentosVenta.map((entity)=>
              <tr className='as' data-toggle='collapse' data-target='#pedidoFact0' aria-expanded='false' aria-controls='col'>
                <td>{entity.tipoDoc}</td>
                <td>{entity.noFactu}</td>
                <td>{entity.estado}</td>
                <td>{moment(entity.fecha).format('DD/MM/YYYY')}</td>
                <td>{entity.moneda}</td>
                <td>{formatMoney(entity.valPreDocu)}</td>
                <td>{entity.tiFactura}</td>
                <td>{entity.parcial}</td>
                <td>{entity.docDevol}</td>
                <td>{entity.noDevol}</td>
            </tr>
            )
          }
        </tbody>
      </table>
    </div>
  </section>
);

class TabFacturacion extends Component{
  constructor(props){
    super(props);
    this.state={
      listadoFacturacion:[],
      rowSelected:'',
      lstDocummentosVenta:[],
      lstHistorialPedido:[],
      lstMovimientosPagos:[]
    }
  }

  loadPedidos = () => {
            this.props.loading('block');
            console.log('result',this.props.pedido.numFichaVtaVeh);
            console.log('result',this.props.pedido.numProfVeh);
            getPedidosPedidos(this.props.pedido.numFichaVtaVeh, [this.props.pedido.numProfVeh]).then((result) => {
                console.log('result',result);
                  let pedido =  _.filter(result, _.property(this.props.pedido.numProfVeh))[0][this.props.pedido.numProfVeh];
                  pedido = pedido.find(entry => entry.numPedidoVeh===this.props.pedido.numPedidoVeh);

                  getHistorialMovPedidos('',pedido.numPedidoVeh,pedido.codProv,pedido.codCia,'123').then(entry => {
                    this.setState({
                      lstDocummentosVenta:entry.data.lstDocummentosVenta,
                      lstHistorialPedido:entry.data.lstHistorialPedido,
                      lstMovimientosPagos:entry.data.lstMovimientosPagos
                    })
                  });
                  this.setState({  pedidos:  pedido});
                  this.props.loading('');
                }).catch((error) => { console.log(error); });

  }

  componentDidMount(){
    this.loadPedidos();
    this.props.loading('block');
    this.props.fetchSolicitudesFacturacion(this.props.fdvID,this.props.selectProforma,this.props.selectPedido)
    .then((result) => {
      console.log(result.payload.data.facturacionResponse);
      this.setState({ listadoFacturacion: result.payload.data.facturacionResponse });
      this.loadPedidos();
      this.props.loading('');
    }).catch((error) => {console.log(error)});
  }


  functionDespliegue = (index) => {
    const isExpanded = index === this.state.rowSelected;
    return isExpanded;
  }

  toggleRow = (index) =>{
    if (index === this.state.rowSelected) {
      this.setState({ rowSelected: '' });
    } else {
      this.setState({ rowSelected: index });
    }
  }



  render(){
    return(
      <div>
          {this.state.listadoFacturacion.length === 0?(
            <div className='tableWrapper'>
            <table className='table table-hover '>
              <tr>
                <td> <p style={{textAling:'center'}}>El pedido no esta facturado !!</p></td>
              </tr>
            </table>
            </div>
          ):(
            <Facturacion
            solicitudfacturacion={this.state.listadoFacturacion }
            solicitudfacturacionEntity={this.state.listadoFacturacion.length>0?this.state.listadoFacturacion[0]:[]}
            selectPedido = {this.props.selectPedido}
            rowSelected= {this.props.rowSelected}
            fdvID ={this.props.fdvID}
            selectPedido = {this.props.selectPedido}
            functionDespliegue = {this.functionDespliegue}
            toggleRow = {this.toggleRow}
            />)
          }
          <TabDocumentos
              lstDocummentosVenta={this.state.lstDocummentosVenta }
          />
          <TabMovimientos
              lstMovimientosPagos={this.state.lstMovimientosPagos }
          />
          <TabHistorialCancelacion
              lstHistorialPedido={this.state.lstHistorialPedido }
          />

      </div>
    )
  }
}

function mapStateToProps(state){
  return{ }
}
export default withRouter(
  connect(mapStateToProps,{
    fetchSolicitudesFacturacion
  })(TabFacturacion)
)



// WEBPACK FOOTER //
// ./src/pages/DetalleFichaVenta/DetallePedido/ItemsDetalle/Facturacion.js